module.exports = __webpack_public_path__ + "static/Abhayraj.d2caf616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Abhayraj.jpg
// module id = 1287
// module chunks = 137408898365125